export default "__VITE_ASSET__dE47QTQI__"